var _circle, _circle2, _path, _path2, _path3, _path4, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep2Current(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 68,
    cy: 68,
    r: 68,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7,
    cx: 68,
    cy: 68,
    r: 62,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 124C98.9279 124 124 98.9279 124 68C124 37.0721 98.9279 12 68 12C37.0721 12 12 37.0721 12 68C12 98.9279 37.0721 124 68 124Z",
    fill: "#EEC98A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.024 81.9069C107.948 83.2784 107.333 84.5643 106.314 85.4848C105.294 86.4053 103.952 86.8861 102.58 86.8224H57.2667C55.8945 86.8861 54.5527 86.4053 53.5332 85.4848C52.5136 84.5643 51.8987 83.2784 51.8223 81.9069V56.738C51.8947 55.365 52.5084 54.0767 53.5289 53.1553C54.5494 52.234 55.8935 51.7547 57.2667 51.8224H66.7089L57.1112 40.2647H56.3801C55.9893 40.2651 55.5991 40.2339 55.2134 40.1713L30.6667 76.1513L23.1689 71.018L50.0178 31.6936C50.479 30.2234 51.437 28.9594 52.7276 28.1179C54.0182 27.2763 55.5613 26.9096 57.0925 27.0806C58.6237 27.2515 60.0479 27.9495 61.1212 29.055C62.1944 30.1604 62.85 31.6046 62.9756 33.1402L78.5312 51.8069H82.4978C83.4959 51.7936 84.4848 51.9983 85.3956 52.4067C86.3064 52.8151 87.1171 53.4173 87.7712 54.1713L105.831 75.9491C107.236 77.6177 108.012 79.7257 108.024 81.9069Z",
    fill: "#DA5042"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8736 69.4155C44.2101 69.4117 44.5431 69.4843 44.8476 69.6278C45.152 69.7714 45.4199 69.9821 45.6311 70.2442C45.8422 70.5063 45.9912 70.8129 46.0667 71.1409C46.1422 71.4689 46.1422 71.8097 46.0669 72.1378C45.4729 74.9246 43.9473 77.4259 41.7415 79.2297C39.5358 81.0335 36.7814 82.0321 33.9321 82.0611C31.0829 82.0901 28.3087 81.1477 26.0667 79.3891C23.8247 77.6306 22.2486 75.1608 21.598 72.3867C21.5077 72.0567 21.4942 71.7104 21.5585 71.3744C21.6228 71.0384 21.7632 70.7215 21.9689 70.4482C22.1747 70.1749 22.4403 69.9523 22.7454 69.7976C23.0505 69.6428 23.387 69.56 23.7291 69.5555L43.8736 69.4155Z",
    fill: "#665F58"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5556 58.1378L96.0001 73.4289C96.2407 73.7427 96.3856 74.1193 96.4174 74.5135C96.4491 74.9077 96.3664 75.3026 96.1791 75.6509C95.9918 75.9992 95.708 76.286 95.3616 76.4768C95.0153 76.6677 94.6212 76.7544 94.2267 76.7267H82.9023C82.4783 76.7522 82.0536 76.6906 81.6543 76.5457C81.255 76.4008 80.8897 76.1757 80.5807 75.8842C80.2717 75.5927 80.0257 75.2411 79.8578 74.8509C79.69 74.4608 79.6037 74.0404 79.6045 73.6156V59.3045C79.6621 58.8725 79.8435 58.4665 80.1269 58.1355C80.4104 57.8045 80.7836 57.5627 81.2015 57.4393C81.6195 57.3159 82.0642 57.3162 82.482 57.4401C82.8997 57.5641 83.2726 57.8064 83.5556 58.1378Z",
    fill: "#E9E7E5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 52.4443,
    y: 85.1111,
    width: 52.8889,
    height: 14,
    rx: 7,
    fill: "#C32B22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2Current);
export default __webpack_public_path__ + "static/media/step2-current.0e2b7f4e3b0d71d3b21abcfb87f3f959.svg";
export { ForwardRef as ReactComponent };